// app/javascript/controllers/category_tree_controller.js
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["subcategories", "link", "caret", "item"]

  connect() {
    document.addEventListener("turbo:before-render", this.handleScroll)
    if (this.itemTarget.dataset.hasSubcategories === "true") {
      const state = JSON.parse(localStorage.getItem("categoryTreeState")) || {}
      const categoryId = this.itemTarget.dataset.categoryId
      let isCollapsed = state[categoryId] !== undefined ? state[categoryId] : true
      const subcategories = this.subcategoriesTarget || null
      const caret = this.caretTarget

      if (isCollapsed && subcategories.classList.contains("max-h-1000px")) {
        const newState = { [categoryId]: false }
        const appendedState = { ...state, ...newState }
        localStorage.setItem("categoryTreeState", JSON.stringify(appendedState))
        isCollapsed = false
      } else if (!isCollapsed && subcategories.classList.contains("max-h-0")) {
        subcategories.classList.replace("max-h-0", "max-h-1000px")
      }

      const subcategoriesClass = isCollapsed ? "max-h-0" : "max-h-1000px"
      const caretClass = isCollapsed ? "rotate-0" : "rotate-90"
      subcategories.classList.add(subcategoriesClass)
      subcategories.classList.remove(isCollapsed ? "max-h-1000px" : "max-h-0")
      caret.classList.add(caretClass)
      caret.classList.remove(isCollapsed ? "rotate-90" : "rotate-0")
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.handleScroll)
  }

  handleScroll = (event) => {
    console.log(event)
    event.detail.renderMethod = "morph"
    // Check if it's a product page
    const isProductPage = event.detail.newBody.dataset.pageType.startsWith("products#show")
    if (!isProductPage) {
      const scrollPosition = window.scrollY
      requestAnimationFrame(() => window.scrollTo(0, scrollPosition))
    }
  }

  toggle(event) {
    // Only handle the toggle click, not the link click
    event.preventDefault()
    event.stopPropagation()

    const subcategories = this.subcategoriesTarget
    const isCollapsed = subcategories.classList.contains("max-h-0")

    if (isCollapsed) {
      subcategories.classList.remove("max-h-0")
      subcategories.classList.add("max-h-1000px")
      this.caretTarget.classList.replace("rotate-0", "rotate-90")
    } else {
      subcategories.classList.remove("max-h-1000px")
      subcategories.classList.add("max-h-0")
      this.caretTarget.classList.replace("rotate-90", "rotate-0")
    }

    // Save the state of the toggle in local storage
    const state = {
      [this.itemTarget.dataset.categoryId]: !isCollapsed,
    }
    const existingState = JSON.parse(localStorage.getItem("categoryTreeState")) || {}
    const newState = { ...existingState, ...state }
    console.log("Saving state:", newState)
    localStorage.setItem("categoryTreeState", JSON.stringify(newState))
  }

  link(event) {
    // Only handle the link click, not the toggle click
    event.preventDefault()
    event.stopPropagation()

    const subcategories = this.subcategoriesTarget
    const isCollapsed = subcategories.classList.contains("max-h-0")

    if (isCollapsed) {
      this.toggle(event)
    }

    Turbo.visit(this.linkTarget.href, { action: "replace" })
  }

  collapseAll(event) {
    event.preventDefault()
    event.stopPropagation()
    // Collapse all subcategories
    const state = {}
    const categoryItems = document.querySelectorAll(".category-item")
    categoryItems.forEach((item) => {
      const subcategories = item.querySelector(".subcategories")
      if (subcategories) {
        subcategories.classList.add("max-h-0")
        subcategories.classList.remove("max-h-1000px")
        const caret = item.querySelector(".caret")
        caret.classList.add("rotate-0")
        caret.classList.remove("rotate-90")
      }
    })
    localStorage.setItem("categoryTreeState", JSON.stringify(state))
  }
}
